import { Auth } from 'aws-amplify';

import {
  SET_LOGGED_IN_USER,
  SET_IS_AUTHENTICATED,
  SET_IS_AUTHENTICATING
} from '../actionTypes';

export function setLoggedInUser() {
  return async function(dispatch) {
    try {
      const user = await Auth.currentAuthenticatedUser();

      dispatch({
        type: SET_LOGGED_IN_USER,
        payload: user
      });
    } catch (e) {
      alert(e.message);
    }
  };
}

export function setIsAuthenticated(authenticated) {
  return function(dispatch) {
    dispatch({
      type: SET_IS_AUTHENTICATED,
      payload: authenticated
    });
  };
}

export function setIsAuthenticating(authenticating) {
  return function(dispatch) {
    dispatch({
      type: SET_IS_AUTHENTICATING,
      payload: authenticating
    });
  };
}

export function logout() {
  return async function(dispatch) {
    try {
      await Auth.signOut();
      setIsAuthenticated(false);

      dispatch({
        type: SET_IS_AUTHENTICATED,
        payload: false
      });
    } catch (e) {
      alert(e.message);
    }
  };
}

export function updateUserAttributes(user, attributes) {
  return async function(dispatch) {
    try {
      await Auth.updateUserAttributes(user, attributes);
      dispatch(setLoggedInUser());
    } catch (e) {
      alert(e.message);
    }
  };
}



// WEBPACK FOOTER //
// ./src/redux/actions/user.js